export default "__VITE_ASSET__DkAjwocq__"